import { withRouter } from 'react-router';

// TODO: Refactor this as a React hook when available:
//       https://github.com/ReactTraining/react-router/issues/6430
const withReactRouter = Component => withRouter(Component);

export default withReactRouter;
